import { StoreSettingTypes as Type } from '../../../types/store';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const StoreEditReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case Type.EDIT_STORE_REQUEST:
      return { ...state, loading: true, error: null, data: null };
    case Type.EDIT_STORE_REQUEST_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
      };
    case Type.EDIT_STORE_REQUEST_FAILURE:
      return { ...state, error: action.error, loading: false, data: null };
    case Type.RESET_EDIT_STORE_STATE:
      return { ...initialState };
    default:
      return state;
  }
};

export default StoreEditReducer;
